const useGetPhoneNumber = (langPrefix: string, product: 'chart' | 'spark' = 'chart') => {
  let numbers = null;
  if (product === 'chart' || product === 'spark') {
    const numbersMap: Record<string, Record<'chart' | 'spark', Record<string, string>>> = {
      default: {
        chart: {
          text: '(855) 917-2480',
          link: 'tel:+18559172480'
        },
        spark: {
          text: '(855) 929-2480',
          link: 'tel:+18559292480'
        }
      },
      en: {
        chart: {
          text: '(855) 917-2480',
          link: 'tel:+18559172480'
        },
        spark: {
          text: '(855) 929-2480',
          link: 'tel:+18559292480'
        }
      },
      de: {
        chart: {
          text: '31 (20) 399-1900',
          link: 'tel:+31203991900'
        },
        spark: {
          text: '31 (10) 899-0377',
          link: 'tel:+31108990377'
        }
      },
      fr: {
        chart: {
          text: '31 (20) 399-1900',
          link: 'tel:+31203991900'
        },
        spark: {
          text: '31 (10) 899-0377',
          link: 'tel:+31108990377'
        }
      },
      nl: {
        chart: {
          text: '31 (20) 399-1900',
          link: 'tel:+31203991900'
        },
        spark: {
          text: '31 (10) 899-0377',
          link: 'tel:+31108990377'
        }
      },
      ja: {
        chart: {
          text: '',
          link: ''
        },
        spark: {
          text: '',
          link: ''
        }
      }
    };

    numbers = numbersMap;
  }

  if (
    numbers &&
    numbers[langPrefix] &&
    numbers[langPrefix][product] &&
    numbers[langPrefix][product].link &&
    numbers[langPrefix][product].text
  ) {
    return numbers[langPrefix][product];
  }

  return null;
};

export default useGetPhoneNumber;
